import { useNavigate } from "react-router";
import { PATH_CONTACT } from "../../../utility/constants";
import { TechFooterSectionType } from "../../../utility/types/generaTypes";
import Button from "../../common/buttons/button/Button";
import "./TechFooter.css";
import { CSSProperties } from "react";

type TechFooterProps = {
  footerData: TechFooterSectionType;
  isThemeChange?: boolean;
  style?: CSSProperties;
};
const TechFooter = ({ footerData, style, isThemeChange }: TechFooterProps) => {
  const navigate = useNavigate();
  return (
    <div className="gradient_bg" style={style}>
      <div className="techFooter">
        <h3 style={{ color: isThemeChange ? "#000" : "#ffff" }}>
          {footerData.title}
        </h3>
        <p style={{ color: isThemeChange ? "#000" : "#ffff" }}>
          {footerData.description}
        </p>
        <Button
          title="Schedule Free Consultation"
          onClickButton={() => navigate(PATH_CONTACT)}
          backgroundColor={
            isThemeChange
              ? "linear-gradient(135deg, hsl(214 84% 56%), hsl(263 70% 50%))"
              : "white"
          }
          borderColor={
            isThemeChange
              ? "linear-gradient(135deg, hsl(214 84% 56%), hsl(263 70% 50%))"
              : "white"
          }
          color={isThemeChange ? "white" : "hsl(214 84% 56%)"}
          className="techFooter_free_consultationBtn"
        />
      </div>
    </div>
  );
};
export default TechFooter;
